<app-page-title [title]="'activity-report.activity-sheet.title'"></app-page-title>

<app-page-menu *ngIf="routeData?.menuList?.length > 0" [menuList]="routeData.menuList"></app-page-menu>

<div @slideInAnimation class="py-2">
  <form [formGroup]="advancedSearchForm" (ngSubmit)="advancedSearchFormSubmit()">
    <div class="row align-items-start align-items-md-center gy-2 py-2">
      <ng-container *ngIf="(listContent?.length > 0) || isSearchActive">
        <ng-template #filtersTpl>
          <isp-advanced-search-filters
            (advancedSearchFormSubmit)="advancedSearchFormSubmit()"
            (reset)="resetSearch()"
            (triggerSort)="sortColumn($event)"
            [advancedFilterData]="advancedFilterData"
            [advancedSearchForm]="advancedSearchForm"
            [basicSearch]="basicSearch"
            [currentScreenInfo]="currentScreenInfo"
            [loader]="loaders['retrieveListContent']"
            [routeData]="routeData"
            [sortDirection]="sortDirection"
            [sort]="sort"
          ></isp-advanced-search-filters>
        </ng-template>

        <ng-container *ngIf="currentScreenInfo.deviceType === DeviceType.Tablet; else responsiveMode">
          <div class="col-12 col-md-8">
            <div class="row">
              <div class="col-12 col-md-6 pr-md-0 mb-2 mb-md-0">
                <input
                  type="text"
                  class="form-control white-input"
                  id="search"
                  [placeholder]="'global.common.search-ellipsis' | translate"
                  [value]="basicSearch"
                  (input)="triggerBasicSearch($event.target.value)"
                />
              </div>
              <div class="col-12 col-md pl-md-0">
                <ng-container *ngTemplateOutlet="filtersTpl"></ng-container>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #responsiveMode>
          <div class="d-flex">
            <input
              type="text"
              class="form-control flex-grow-1"
              id="search"
              [placeholder]="'global.common.search-ellipsis' | translate"
              [value]="basicSearch"
              (input)="triggerBasicSearch($event.target.value)"
            />
            <ng-container *ngTemplateOutlet="filtersTpl"></ng-container>
          </div>
        </ng-template>
      </ng-container>

      <div class="col-12 col-md d-flex justify-content-md-end justify-content-start">
        <!-- Buttons -->
      </div>
    </div>
  </form>
</div>


  <ng-container *ngIf="!firstCallDone; else firstCallDoneBlock">
    <app-spinner [backgroundTransparent]="true"></app-spinner>
  </ng-container>

  <ng-template #firstCallDoneBlock>
    <div @slideInAnimation>
      <div *ngIf="listContent.length > 0; else noResult">
        <isp-responsive-table [dataSource]="listContent" [displayedColumns]="routeData.columns"
                              [sortDirection]="sortDirection"
                              [sort]="sort">
          <ng-container
            (trigger)="sortColumn(ColumnsEnum.id)"
            *ngIf="checkColumn(ColumnsEnum.id)"
            [headerCellDef]="getColumnKey(ColumnsEnum.id)"
            [ispColumnDef]="ColumnsEnum.id"
          >
            <ng-template ispCellDef let-element>
              {{ formatActivityDisplayId('TS', element.id) }}
            </ng-template>
          </ng-container>

          <ng-container
            (trigger)="sortColumn(ColumnsEnum.buyerCompanyName)"
            *ngIf="checkColumn(ColumnsEnum.buyerCompanyName)"
            [headerCellDef]="getColumnKey(ColumnsEnum.buyerCompanyName)"
            [ispColumnDef]="ColumnsEnum.buyerCompanyName"
          >
            <ng-template ispCellDef let-element>
              <ng-container *ngIf="element.parentBuyerName">
                <fa-icon [icon]="faBuildings" [tooltip]="element.parentBuyerName" class="mr-2"></fa-icon>
              </ng-container>
              <a
                [routerLink]="['/companies/',element.buyerId,'update','informations','legal-information']">{{ element.buyerCompanyName }}</a>
            </ng-template>
          </ng-container>

          <ng-container
            (trigger)="sortColumn(ColumnsEnum.supplierCompanyName)"
            *ngIf="checkColumn(ColumnsEnum.supplierCompanyName)"
            [headerCellDef]="getColumnKey(ColumnsEnum.supplierCompanyName)"
            [ispColumnDef]="ColumnsEnum.supplierCompanyName"
          >
            <ng-template ispCellDef let-element>
              <a
                [routerLink]="['/companies/',element.supplierId,'update','informations','legal-information']">{{ element.supplierCompanyName }}</a>
            </ng-template>
          </ng-container>

          <ng-container
            (trigger)="sortColumn(ColumnsEnum.purchaseOrderNumber)"
            *ngIf="checkColumn(ColumnsEnum.purchaseOrderNumber)"
            [headerCellDef]="getColumnKey(ColumnsEnum.purchaseOrderNumber)"
            [ispColumnDef]="ColumnsEnum.purchaseOrderNumber"
          >
            <ng-template ispCellDef let-element>
              <ng-container *ngIf="!element.requestId">
                {{ element.purchaseOrderNumber }}
              </ng-container>
              <a *ngIf="element.requestId"
                 [routerLink]="['/requests',element.requestId,'detail']">{{ element.purchaseOrderNumber }}</a>

            </ng-template>
          </ng-container>

          <ng-container
            (trigger)="sortColumn(ColumnsEnum.projectName)"
            *ngIf="checkColumn(ColumnsEnum.projectName)"
            [headerCellDef]="getColumnKey(ColumnsEnum.projectName)"
            [ispColumnDef]="ColumnsEnum.projectName"
          >
            <ng-template ispCellDef let-element>
              {{ element.projectName }}
            </ng-template>
          </ng-container>

          <ng-container
            (trigger)="sortColumn(ColumnsEnum.employeeName)"
            *ngIf="checkColumn(ColumnsEnum.employeeName)"
            [headerCellDef]="getColumnKey(ColumnsEnum.employeeName)"
            [ispColumnDef]="ColumnsEnum.employeeName"
          >
            <ng-template ispCellDef let-element>
              <ng-container *ngIf="!element.employeeId">
                {{ element.employeeName }}
              </ng-container>
              <a *ngIf="element.employeeId"
                 [routerLink]="['/companies', element.supplierId, 'update','directories','employees',element.employeeId,'update']">{{ element.employeeName }}</a>
            </ng-template>
          </ng-container>

          <ng-container
            (trigger)="sortColumn(ColumnsEnum.startDate)"
            *ngIf="checkColumn(ColumnsEnum.startDate)"
            [headerCellDef]="getColumnKey(ColumnsEnum.startDate)"
            [ispColumnDef]="ColumnsEnum.startDate"
          >
            <ng-template ispCellDef let-element>
              {{ element.startDate | localizedDate }} - {{ element.endDate | localizedDate }}
            </ng-template>
          </ng-container>

          <ng-container
            (trigger)="sortColumn(ColumnsEnum.submissionDate)"
            *ngIf="checkColumn(ColumnsEnum.submissionDate)"
            [headerCellDef]="getColumnKey(ColumnsEnum.submissionDate)"
            [ispColumnDef]="ColumnsEnum.submissionDate"
          >
            <ng-template ispCellDef let-element>
              {{ element.submissionDate | localizedDate }}
            </ng-template>
          </ng-container>

          <ng-container
            (trigger)="sortColumn(ColumnsEnum.validationDate)"
            *ngIf="checkColumn(ColumnsEnum.validationDate)"
            [headerCellDef]="getColumnKey(ColumnsEnum.validationDate)"
            [ispColumnDef]="ColumnsEnum.validationDate"
          >
            <ng-template ispCellDef let-element>
              {{ element.validationDate | localizedDate }}
            </ng-template>
          </ng-container>

          <ng-container
            *ngIf="checkColumn(ColumnsEnum.sum)"
            [headerCellDef]="getColumnKey(ColumnsEnum.sum)"
            [ispColumnDef]="ColumnsEnum.sum"
          >
            <ng-template ispCellDef let-element>
              {{ element.sum | localizedQuantity:element.type }}
            </ng-template>
          </ng-container>

          <ng-container
            (trigger)="sortColumn(ColumnsEnum.status)"
            *ngIf="checkColumn(ColumnsEnum.status)"
            [headerCellDef]="getColumnKey(ColumnsEnum.status)"
            [ispColumnDef]="ColumnsEnum.status"
          >
            <ng-template ispCellDef let-element>
              {{ 'activity-report.status.' + element.status | translate }}
            </ng-template>
          </ng-container>

          <ng-container [ispColumnDef]="ActionsEnum.actions">
            <ng-template ispCellDef let-element>
              <isp-button
                [type]="ButtonTypeEnum.ICON"
                [colour]="IspColoursEnum.secondary"
                [icon]="faComment"
                [size]="SizeEnum.xs"
                [tooltip]='element.comment'
                *ngIf="element.comment"
              ></isp-button>
              <isp-button
                [type]="ButtonTypeEnum.ICON"
                [colour]="IspColoursEnum.tertiary"
                [icon]="faComment"
                [size]="SizeEnum.xs"
                [tooltip]='element.refusalComment'
                *ngIf="element.refusalComment && element.status === ActivitySheetStatusEnum.REFUSED"
              ></isp-button>
              <isp-button
                (trigger)="sendReminder(element)"
                *ngIf="element.reminderAvailable"
                @fadeOut
                [colour]="IspColoursEnum.primary"
                [icon]="faBell"
                [size]="currentScreenInfo.deviceType === DeviceType.Smartphone ? SizeEnum.normal : SizeEnum.xs"
                [tooltip]="'activity-report.activity-sheet.tooltips.remind-users'|translate"
                [type]="ButtonTypeEnum.ICON"
              ></isp-button>
              <isp-button
                (trigger)="confirmTimesheetModeration(ActivitySheetStatusEnum.VALIDATED, element)"
                *ngIf="element.sum === 0 && element.status === ActivitySheetStatusEnum.SUBMITTED"
                @fadeOut
                [colour]="IspColoursEnum.primary"
                [icon]="faCheck"
                [size]="currentScreenInfo.deviceType === DeviceType.Smartphone ? SizeEnum.normal : SizeEnum.xs"
                [tooltip]="'activity-report.activity-sheet.tooltips.validate-activity-sheet'|translate"
                [type]="ButtonTypeEnum.ICON"
              ></isp-button>
              <isp-button
                (trigger)="confirmTimesheetModeration(ActivitySheetStatusEnum.SUBMITTED, element)"
                *ngIf="element.sum === 0 && [ActivitySheetStatusEnum.DRAFT].includes(element.status)"
                [disabled]="!element.allowedToTransmit"
                @fadeOut
                [colour]="IspColoursEnum.primary"
                [icon]="faCalendarCheck"
                [size]="currentScreenInfo.deviceType === DeviceType.Smartphone ? SizeEnum.normal : SizeEnum.xs"
                [tooltip]="getSubmitTooltipText(element)"
                [type]="ButtonTypeEnum.ICON"
              ></isp-button>
              <isp-button
                (trigger)="confirmTimesheetModeration(ActivitySheetStatusEnum.CANCELLED, element)"
                *ngIf="displayCancel(element)"
                @fadeOut
                [colour]="IspColoursEnum.secondary"
                [icon]="faBan"
                [size]="currentScreenInfo.deviceType === DeviceType.Smartphone ? SizeEnum.normal : SizeEnum.xs"
                [tooltip]="'activity-report.activity-sheet.tooltips.cancel-activity-sheet'|translate"
                [type]="ButtonTypeEnum.ICON"
              ></isp-button>
            </ng-template>
          </ng-container>
        </isp-responsive-table>

        <isp-pagination
          (changePage)="changePage($event)"
          (changeSize)="changeSize()"
          [(size)]="size"
          [currentScreenInfo]="currentScreenInfo"
          [numberOfElements]="numberOfElements"
          [page]="page"
          [totalElements]="totalElements"
        ></isp-pagination>
      </div>
    </div>

    <ng-template #noResult>
      <div class="slide-in-animation">
        <app-no-data></app-no-data>
      </div>
    </ng-template>
  </ng-template>

